import _ from 'lodash'

_.mixin({
    'omitDeep': function (obj, predicate) {
        return _.transform(obj, function (result, value, key) {
            if (_.isObject(value)) {
                value = _.omitDeep(value, predicate);
            }
            var doOmit = predicate(value, key);
            if (!doOmit) {
                _.isArray(obj) ? result.push(value) : result[key] = value;
            }
        });
    }
});

_.mixin({
    'removeDeepByKey': function (obj, keyToBeRemoved) {
        const object = _.transform(obj, function (result, value, key) {
            if (_.isObject(value)) {
                value = _.removeDeepByKey(value, keyToBeRemoved);
            }
            if (key !== keyToBeRemoved) {
                _.isArray(obj) ? result.push(value) : result[key] = value;
            }
        });

        return object;
    }
});

_.mixin({
    'isNumeric': function (obj) {
        return _.transform(obj, function(result, value) {
            if (typeof value === 'number') return true;
            const str = (value || '').toString();
            if (!str) return false;
            return !isNaN(str);
        });
    }
});

let collection = [];

_.mixin({
    'enhancedGet': function(object, path, defaultValue) {
        let result, parts = path.split('*');

        if (parts.length <= 1) {
            result = _.get(object, path, defaultValue);
        } else {
            path = _.trim(parts.shift(), '.');
            let remainingPath = _.trim(parts.join('*'), '.');

            let data = object
            if (path) data = _.get(object, path)

            if (data && data.length) {
                data.forEach(item => {
                    const nextLevelResult = _.enhancedGet(item, remainingPath, defaultValue);
                    if (parts.length == 1) collection.push(nextLevelResult);
                })
            }

            result = _.compact(collection);
            collection = [];
        }

        return result;
    }
});

// /**
//  * Get the first item that pass the test
//  * by second argument function
//  *
//  * @param {Array} list
//  * @param {Function} f
//  * @return {*}
//  */
// function find (list, f) {
//     return list.filter(f)[0]
// }

// /**
//  * Deep copy the given object considering circular structure.
//  * This function caches all nested objects and its copies.
//  * If it detects circular structure, use cached copy to avoid infinite loop.
//  *
//  * @param {*} obj
//  * @param {Array<Object>} cache
//  * @return {*}
//  */
// export function deepCopy (obj, cache = []) {
//     // just return if obj is immutable value
//     if (obj === null || typeof obj !== 'object') {
//         return obj
//     }

//     // if obj is hit, it is in circular structure
//     const hit = find(cache, c => c.original === obj)
//     if (hit) {
//         return hit.copy
//     }

//     const copy = Array.isArray(obj) ? [] : {}
//     // put the copy into cache at first
//     // because we want to refer it in recursive deepCopy
//     cache.push({
//         original: obj,
//         copy
//     })

//     Object.keys(obj).forEach(key => {
//         copy[key] = deepCopy(obj[key], cache)
//     })

//     return copy
// }

// /**
//  * forEach for object
//  */
// export function forEachValue (obj, fn) {
//     Object.keys(obj).forEach(key => fn(obj[key], key))
// }

// export function isObject (obj) {
//     return obj !== null && typeof obj === 'object'
// }

// export function isPromise (val) {
//     return val && typeof val.then === 'function'
// }

// export function assert (condition, msg) {
//     if (!condition) throw new Error(`[vuex] ${msg}`)
// }
